export default "__VITE_ASSET__Coyhh5AR__"